import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { displayName, navigate, safeRoute, userSlug } from '../../utils';
const FALLBACK_GRADIENTS = ['linear-gradient(135deg,#ffd166,#f28482)', 'linear-gradient(135deg,#89cff0,#6b7fc4)', 'linear-gradient(135deg,#9eea6c,#337d63)', 'linear-gradient(135deg,#f0b213,#e84393)', 'linear-gradient(135deg,#c5ccff,#b5e3ff)', 'linear-gradient(135deg,#ffb5a7,#fcd5ce)'];

/**
 * Reads the online-user payload injected server-side into <head> as
 * `window.__avocadoOnlineUsers` by Content\InjectOnlineUsers — the single
 * source of truth (it used to be duplicated as an `avocadoOnlineUsers` forum
 * API attribute, which ran the same users-table scan twice per page load).
 * Returns an empty array when the feature is off or the payload is missing.
 */
function getOnlineUsers() {
  const list = window.__avocadoOnlineUsers;
  return Array.isArray(list) ? list : [];
}

/**
 * OnlineUsers — compact avatar row for currently-online members.
 *
 * Renders nothing when:
 *  - the `avocadoShowOnlineUsers` setting is off, or
 *  - the backend has not exposed an online-users list.
 *
 * Used by HomePage and AllDiscussionsPage. Both pages used to inline this
 * markup with subtly different render logic — kept in sync here.
 */
export default class OnlineUsers extends Component {
  view() {
    if (!app.forum?.attribute('avocadoShowOnlineUsers')) return null;
    const users = getOnlineUsers();
    if (!users.length) return null;
    const maxShown = this.attrs.maxShown ?? 6;
    const total = users.length;
    const shown = users.slice(0, maxShown);
    // Backend may emit either Flarum models or plain `{ id, username, ... }` objects.
    const isPlain = shown[0] && typeof shown[0].username === 'string';
    const wrapperClass = ['AvocadoHome-onlineAvatars', this.attrs.className].filter(Boolean).join(' ');
    return m("div", {
      className: wrapperClass
    }, m("div", {
      className: "AvocadoHome-onlineAvatars-row"
    }, shown.map((user, i) => this.renderAvatar(user, i, isPlain))), app.forum?.attribute('avocadoShowOnlineCount') !== false && m("span", {
      className: "AvocadoHome-onlineAvatars-count"
    }, total, " ", app.translator.trans('ramon-avocado.forum.online_users.online')));
  }
  renderAvatar(user, index, isPlain) {
    const key = isPlain ? user.id : user.id?.();
    const userModel = isPlain ? key ? app.store.getById('users', String(key)) : null : user;
    // `slug` vem do slug driver configurado (Content\InjectOnlineUsers); o
    // username só é fallback para um payload antigo ainda no cache de 30s.
    const slug = userSlug(userModel) || (isPlain ? user.slug || user.username : '');
    const name = userModel?.displayName?.() || userModel?.username?.() || (isPlain ? user.displayName || user.username : displayName(user));
    const avatarUrl = userModel?.avatarUrl?.() || (isPlain ? user.avatarUrl || null : null);
    const profileHref = safeRoute('user', {
      username: slug
    });
    const fallbackBg = FALLBACK_GRADIENTS[index % FALLBACK_GRADIENTS.length];
    return m("a", {
      key: key,
      className: "AvocadoHome-onlineAvatars-item",
      href: profileHref,
      onclick: e => {
        e.stopPropagation();
        navigate(e, profileHref);
      },
      title: name,
      style: avatarUrl ? {} : {
        background: fallbackBg
      }
    }, avatarUrl && m("img", {
      src: avatarUrl,
      alt: name,
      className: "Avatar",
      width: "28",
      height: "28",
      decoding: "async"
    }));
  }
}
flarum.reg.add('ramon-avocado', 'forum/components/shared/OnlineUsers', OnlineUsers);